package com.kinoshazam.screens.profile.host

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.kinoshazam.screens.profile.compact.CompactProfileContent
import com.kinoshazam.screens.profile.expanded.ExpandedProfileContent
import com.kinoshazam.screens.profile.medium.MediumProfileContent
import org.koin.compose.viewmodel.koinViewModel
import presentation.screens.profile.ProfileViewModel
import utils.FormFactor

@Composable
fun ProfileContentHost(
    formFactor: FormFactor,
) {
    val viewModel = koinViewModel<ProfileViewModel>()
    val state by viewModel.state.collectAsStateWithLifecycle()

    when (formFactor) {
        FormFactor.Compact -> CompactProfileContent(
            state = state,
            onAction = viewModel::onAction
        )

        FormFactor.Medium -> CompactProfileContent(
            state = state,
            onAction = viewModel::onAction
        )

        FormFactor.Expanded -> MediumProfileContent(
            state = state,
            onAction = viewModel::onAction
        )

        FormFactor.ExtraLarge -> ExpandedProfileContent(
            state = state,
            onAction = viewModel::onAction
        )
    }

}
